export default {
      id: "grip-lines-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#grip-lines-usage",
      toString: function () {
        return this.url;
      }
    }